/*
 * @Description: web_workgroup_picspage_click 补充字段（string7 / phototype），20260414
 */
import type { RootState } from '../../../app/store'

/** clickItem=出现补充结果 时 string7，与 fallbackType 对应 */
function supplementaryString7FromFallback(
  fallbackType: 'none' | 'P1' | 'P2' | 'P3' | undefined
): string {
  if (fallbackType === 'P2') return '放开时间结果照片'
  if (fallbackType === 'P3') return '放开人员结果照片'
  return '可能相关结果照片'
}

/** clickItem=photo / 全选单选 等需区分普通/补充结果照片时 phototype */
function phototypeFromTabAndFallback(
  tabName: string | undefined,
  fallbackType: 'none' | 'P1' | 'P2' | 'P3' | undefined
): string {
  const isSuggested = tabName === 'suggested'
  if (!isSuggested) {
    return '普通照片'
  }
  if (fallbackType === 'P2') return '放开时间结果照片'
  if (fallbackType === 'P3') return '放开人员结果照片'
  return '可能相关结果照片'
}

/**
 * 合并 string7、phototype（不覆盖调用方已为「补充结果」以外场景传入的 string7，如主列表 photo 预览的拍照时间）
 */
export function applyPicPageClickSupplementFields(
  trackParams: Record<string, any>,
  state: RootState,
  clickItem: string
): void {
  const fb = state.photosByContent?.fallbackType

  if (clickItem === '出现补充结果' || clickItem === '出现猜你想搜') {
    trackParams.string7 = supplementaryString7FromFallback(fb)
  }

  if (
    clickItem === 'photo' ||
    clickItem === 'chooseAll' ||
    clickItem === 'cancelChooseAll' ||
    clickItem === 'chooseOnePhoto' ||
    clickItem === 'cancelChooseOnePhoto'
  ) {
    trackParams.phototype = phototypeFromTabAndFallback(trackParams.tabName, fb)
  }
}
